import { useRef, useEffect, DependencyList } from 'react';

export default function useEffectFirst(effect: (isFirst: boolean) => void, dependecies: DependencyList) {
  const first = useRef<boolean>(true);

  useEffect(function () {
    const isFirst = first.current;
    if (isFirst) first.current = false;
    return effect(isFirst);
  }, dependecies);
}
